import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        height: 60,
    },
    button: {
        width: '100%',
        fontWeight: '600',
        fontSize: '13px'
    },
}));

export default useStyles;
